import React from "react";
import { Persona } from "@soulmachines/smwebsdk";
import { ImgCtaButtonsTypes } from "../../../types/ContentCard";
import { ImgCtaContainer } from "./ImgCtaButtonsStyles";
import { detectDeviceType } from "../../../utils/detectDeviceType";

const ImgCtaButtons: React.FC<{
  contentCardData: ImgCtaButtonsTypes;
  tabletLandscape: boolean;
  persona: Persona;
  dispatch: Function;
  active: boolean;
}> = ({ contentCardData, tabletLandscape, persona, dispatch, active }) => {
  return (
    <ImgCtaContainer
      deviceType={detectDeviceType()}
      isLandscape={tabletLandscape}
      data-sm-content="imgCtaButtons"
    >
      {contentCardData.data.pictureUrl && (
        <img
          src={contentCardData.data.pictureUrl}
          alt={contentCardData.data.pictureAlt}
        />
      )}
      {contentCardData.data.title && <h1>{contentCardData.data.title} </h1>}

      <div>
        {contentCardData.data.buttons.map((ctaButton, i) => {
          return (
            <button
              key={i}
              disabled={ctaButton.linkValue ? false : !active}
              type="button"
              onClick={() => {
                if (ctaButton.linkValue) {
                  return window.open(
                    ctaButton.linkValue,
                    "_blank",
                    "noopener,noreferrer"
                  );
                }
                persona.conversationSend(ctaButton.buttonValue, {}, {});
                dispatch({
                  type: "ADD_CONVERSATION_MESSAGE",
                  payload: {
                    source: "user",
                    text: ctaButton.buttonText,
                  },
                });
              }}
              data-tracking={
                ctaButton.dataTracking ? ctaButton.dataTracking : ""
              }
            >
              {ctaButton.buttonText}
            </button>
          );
        })}
      </div>
    </ImgCtaContainer>
  );
};

export default ImgCtaButtons;
